import React from 'react';

import { IconProps } from './type';

const FrontageIcon: React.FC<React.SVGProps<'svg'> & IconProps> = ({
  className = '',
  size = 24,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <rect x="1" y="1" width="12" height="12" rx="4" fill="white" />
    <path
      d="M3.72424 12.6779C3.71993 12.6825 3.71415 12.6851 3.70812 12.6851C3.70209 12.6851 3.6963 12.6825 3.692 12.6779C3.46172 12.3987 1 9.3503 1 7.33058C1 4.83045 2.49683 4.25195 3.70812 4.25195C4.82268 4.25195 6.25504 4.90591 6.25504 7.33058C6.25504 9.4157 3.9384 12.4038 3.72424 12.6779Z"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      d="M3.62704 7.9793C4.23115 7.9793 4.72088 7.4444 4.72088 6.78457C4.72088 6.12474 4.23115 5.58984 3.62704 5.58984C3.02293 5.58984 2.5332 6.12474 2.5332 6.78457C2.5332 7.4444 3.02293 7.9793 3.62704 7.9793Z"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      d="M11.0102 7.63766C11.0055 7.64243 10.9993 7.64509 10.9929 7.64509C10.9865 7.64509 10.9804 7.64243 10.9757 7.63766C10.7753 7.38614 8.85938 5.00926 8.85938 3.42719C8.85938 1.45525 10.0384 1 10.9941 1C11.8715 1 12.9998 1.50304 12.9998 3.42719C12.9998 5.05956 11.199 7.3962 11.0102 7.63766Z"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      d="M10.93 4.1911C11.4069 4.1911 11.7935 3.76881 11.7935 3.24789C11.7935 2.72698 11.4069 2.30469 10.93 2.30469C10.453 2.30469 10.0664 2.72698 10.0664 3.24789C10.0664 3.76881 10.453 4.1911 10.93 4.1911Z"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      d="M3.70898 12.6992C4.00323 12.7965 4.30332 12.8713 4.60708 12.9231"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      d="M5.27539 12.9952C5.91788 13.0254 6.62254 12.9248 7.09462 12.472C8.43026 11.1918 7.76014 9.64241 8.64902 8.77214C8.98455 8.45065 9.3687 8.19533 9.78431 8.01758"
      stroke="currentColor"
      strokeWidth="0.5"
      strokeDasharray="97.5 36.5"
    />
    <path
      d="M10.1016 7.89715C10.3925 7.78935 10.6914 7.7094 10.9951 7.6582"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
);

export default FrontageIcon;
